import _ from 'lodash';

export const mapRemoteDataToTable = data =>
  data
    ?.sort((a, b) => +a.sortNumber - +b.sortNumber)
    .map(i => ({
      ...i,
      id: i.contentId,
      originalId: i.id,
      type: i.type || i.contentType,
    }));

export const mapTableDataToRemote = (
  data,
  fields = ['all', 'contentId', 'id']
  // createSortNumber => create createSortNumber to item if does not exist
) =>
  data
    ?.sort((a, b) => +a.sortNumber - +b.sortNumber)
    .map((i, index) => {
      const formattedData = { ...i, contentId: i.id, id: i.originalId };

      if (fields.includes('createSortNumber')) {
        formattedData.sortNumber = index;
        fields.push('sortNumber');
      }

      if (fields.includes('contentType'))
        formattedData.contentType =
          formattedData.contentType || formattedData.type;

      if (fields.includes('type'))
        formattedData.type = formattedData.contentType || formattedData.type;

      if (fields.includes('all')) return formattedData;

      return _.pick(formattedData, fields);
    });

export const getCurrentRelatedCollectionUpdate = ({
  currentRelatedCollection,
  initialtRelatedCollection,
}) => {
  const currentRelatedCollectionIds = currentRelatedCollection?.map(i => i.id);

  const itemsToDelete = initialtRelatedCollection?.filter(
    initialCollection =>
      !currentRelatedCollectionIds?.includes(initialCollection.id)
  );

  const itemsToDeleteIds = itemsToDelete?.map(i => i.id);

  const itemsToUpdate = currentRelatedCollection?.filter(
    current => !itemsToDeleteIds?.includes(current.id)
  );

  return {
    toDelete: itemsToDeleteIds,
    toUpdate: itemsToUpdate,
    toDeleteIds: itemsToDeleteIds,
    toUpdateIds: itemsToUpdate?.map(i => i.id),
  };
};

export const collectionMapRemoteDataToTable = data =>
  data
    ?.sort((a, b) => +a.sortNumber - +b.sortNumber)
    .map(i => ({
      ...i,
      id: i?.video?.videoId,
      contentId: i?.video?.videoId,
      originalId: i?.video?.videoId,
      type: i.contentType || 'VIDEO',
    }));

export const mapVideoCollectionFormat = videos => {
  return videos.map((video, index) => ({
    video: {
      videoId: video.contentId || video.id,
    },
    sortNumber: index + 1,
    nextSuggestionTimeSeconds: video.nextSuggestionTimeSeconds || 60,
  }));
};
